import React from 'react';
import { careGuides } from '../mockData/mock';
import { Wrench, CheckCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const CareGuides = () => {
  return (
    <div className="min-h-screen bg-[#f7f5f2]">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-white to-[#f7f5f2] py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center space-x-2 bg-[#a8b5a0]/10 px-4 py-2 rounded-full mb-6">
            <Wrench className="h-5 w-5 text-[#a8b5a0]" />
            <span className="text-sm font-medium text-[#736c64]">Maintain Your Tools</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#1e1919] mb-6">
            Care & Tool Guides
          </h1>
          <p className="text-xl text-[#736c64] max-w-2xl mx-auto">
            Keep your Hearthlowe tools in perfect condition with our detailed care instructions.
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-lg text-[#736c64] leading-relaxed text-center">
            Your Hearthlowe Sourdough Baking Kit contains carefully selected tools designed to last for years. 
            Proper care ensures they'll be with you for countless loaves to come.
          </p>
        </div>
      </section>

      {/* Care Guides */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12">
            {careGuides.map((guide) => (
              <Card key={guide.id} className="overflow-hidden hover:shadow-lg transition-shadow">
                <div className="md:flex">
                  <div className="md:w-2/5">
                    <img
                      src={guide.image}
                      alt={guide.item}
                      className="w-full h-64 md:h-full object-cover"
                    />
                  </div>
                  <div className="md:w-3/5">
                    <CardContent className="p-8">
                      <h2 className="text-2xl font-bold text-[#1e1919] mb-6">
                        {guide.item}
                      </h2>
                      <ul className="space-y-4">
                        {guide.care.map((instruction, index) => (
                          <li key={index} className="flex items-start gap-3">
                            <CheckCircle className="h-5 w-5 text-[#a8b5a0] flex-shrink-0 mt-0.5" />
                            <span className="text-[#736c64] leading-relaxed">
                              {instruction}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </CardContent>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Tips Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-[#a8b5a0]/10 to-transparent rounded-2xl p-8 border border-[#e8e6e1]">
            <h2 className="text-2xl font-bold text-[#1e1919] mb-4">
              General Care Tips
            </h2>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="text-[#a8b5a0] mt-1">•</span>
                <span className="text-[#736c64]">
                  Store all tools in a dry, well-ventilated area to prevent moisture damage
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#a8b5a0] mt-1">•</span>
                <span className="text-[#736c64]">
                  Clean tools immediately after use before dough dries for easier maintenance
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#a8b5a0] mt-1">•</span>
                <span className="text-[#736c64]">
                  Inspect wooden items periodically and apply food-safe mineral oil if they appear dry
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#a8b5a0] mt-1">•</span>
                <span className="text-[#736c64]">
                  Replace blades and liners as needed - we'll have replacement parts available soon
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CareGuides;
